<template>
    <div class="selectize"
         :class="{ 'active': hasValue }"
    >
        <label :for="labelFor" v-if="labelFor.length > 0">
            {{ labelPlaceholder }}
        </label>
        <v-selectize v-model="selected"
                     :options="options"
                     :create-item="false"
                     :searchFn="search"
                     :limit="limit"
                     :placeholder="placeholder"
                     label="city_zip"
                     key-by="id"
                     disableSearch
        >
        <template slot="item" slot-scope="{item}">{{ item.zip }}</template>

        </v-selectize>

        <input type="hidden" :value="value" :name="name">
    </div>
</template>

<script>
import VSelectize from '@isneezy/vue-selectize'
import { debounce } from 'lodash'

export default {
    props: {
        type: {
            required: false,
            type: String,
            default: 'account'
        },
        name: {
            required: true,
            type: String
        },
        id: {
            required: false,
            type: String,
            default: ''
        },
        placeholderProp: {
            required: true,
            type: String
        },
        valueProp: {
            required: true,
            type: String,
            default: null
        },
        zipId: {
            required: false,
            type: String,
            default: null
        },
        labelFor: {
            required: false,
            type: String,
            default: ''
        },
        labelPlaceholder: {
            required: false,
            type: String
        }
    },

    data() {
        return {
            selected: null,
            options: [],
            limit: 20,
            value: this.valueProp,
            placeholder: this.placeholderProp,
            hasValue: false
        }
    },

    created () {
      if ( this.value.length ) {
          this.hasValue = true;
          this.placeholder = this.value;
      }

      this.handleZipId();
    },

    methods: {

        search: debounce( function (text, done)  {
            if ( text.length < 3 ) done();

            axios.post('/api/backend/zip', { s: text })
                .then( response => {
                    this.options = response.data.places;
                    done();
                })
                .catch( error => console.log(error) );
        }, 200),

        setCity() { this.$root.$emit('updateCity', [this.value, this.type]) },

        handleZipId() {
            if ( this.zipId !== null && this.zipId.length )
                this.value = this.zipId
        }
    },

    watch: {
        selected: function ( {id} ) {
            this.value = id;
            this.setCity();
        }
    },

    components: {
        VSelectize
    }
}
</script>

<style lang="scss">
.selectize {

    &.active {

        input::placeholder {
            color: #000;
        }
    }

    .selectize-control {

        &.loading {
            position: static !important;
        }
    }

    input {
        display: inline-block !important;
        padding: 0 !important;
        min-height: 0 !important;
        max-height: none !important;
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 1px !important;
        text-indent: 0 !important;
        border: 0 none !important;
        background: none !important;
        line-height: inherit !important;
        -webkit-user-select: auto !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }

    .selectize-input {
        height: 50px;
        border: 1px solid #505050;
        background: white;
        border-radius: 3px;
        font-family: "Mulish", sans-serif;
        color: black;
        padding: 0 20px;
        overflow: hidden;
        position: relative;

        &.has-items {

            input {
                width: 4px !important;
            }
        }

        //&.dropdown-active::before {
        //    content: ' ';
        //    display: block;
        //    position: absolute;
        //    background: #f0f0f0;
        //    height: 1px;
        //    bottom: 0;
        //    left: 0;
        //    right: 0;
        //}

        & > * {
            display: inline-block;
        }
    }

    .selectize-control.single .selectize-input:after {
        content: ' ';
        display: block;
        position: absolute;
        top: 50%;
        right: 15px;
        margin-top: -3px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 5px 0 5px;
        border-color: #808080 transparent transparent transparent;
    }

    .selectize-control.single .selectize-input.dropdown-active:after {
        margin-top: -4px;
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #808080 transparent;
    }

    .selectize-dropdown {
        position: relative;

        .selectize-dropdown-content {
            position: absolute;
            width: 100%;
            z-index: 99;

            div {
                color: #000;
                background-color: #F5F5F5;
                width: 100%;
                border: 1px solid #E0E0E0;
                border-top: none;
                padding: 5px 0 5px 10px;
                cursor: pointer;

                &:last-child {
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                }

                &.active {
                    background-color: darken(#F5F5F5, 5%);
                }
            }
        }
    }
}
</style>
